// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ij3v","footer":"styles_footer__tO6Jt"};